





































import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "./Header.vue";
import Botao from "./Botao.vue";
import ParaQuem from "./ParaQuem.vue";
import Frase1 from "./Frase1.vue";
import Frase2 from "./Frase2.vue";
import Frase3 from "./Frase3.vue";
import TipoDificuldade from "./TipoDificuldade.vue";
import Metodo from "./Metodo.vue";
import Conteudo from "./Conteudo.vue";
import Kimtara from "./Kimtara.vue";
import Clientes from "./Clientes.vue";
import Videos from "./Videos.vue";
import Bonus from "./Bonus.vue";
import Preco from "./Preco.vue";
import PerguntasFreq from "./PerguntasFreq.vue";
import Conteudo2 from "./Conteudo2.vue";
import Reembolso from "./Reembolso.vue";
import FirstVideo from "./FirstVideo.vue";
import Beneficios from "./Beneficios.vue";
import PerguntasFreq2 from "./PerguntasFreq2.vue";
import PrecoSimples from "./PrecoSimples.vue";
import PrecoSimplesWhite from "./PrecoSimplesWhite.vue";

@Component({
  components: {
    Botao,
    Header,
    ParaQuem,
    Frase1,
    Frase2,
    Frase3,
    TipoDificuldade,
    Metodo,
    Conteudo,
    Kimtara,
    Clientes,
    Videos,
    Bonus,
    Preco,
    Conteudo2,
    PerguntasFreq,
    Reembolso,
    FirstVideo,
    Beneficios,
    PerguntasFreq2,
    PrecoSimples,
    PrecoSimplesWhite
  }
})
export default class Index extends Vue {
  @Prop() private msg!: string;
}
